import React from 'react';


function Advert() {

  return <>
    <div className='advert'>
        <h1>INFORMUOJAME</h1>
        {/* <p className='nedirbam'>Gruodžio 22- Sausio 5 dienomis nedirbame</p> */}
        <p>Informuojame, kad informaciją apie paramą katilų keitimui galite rasti Lietuvos energetikos agentūros svetainėje (LEA, <a className='EnaLink' href='https://www.ena.lt/inpa-katilokeita/'>ena.lt</a>).</p>
        <p>Sekantis etapas planuojamas 2026 m. spalio 1 d. (biomasę ir iškastinį kurą naudojančių katilų keitimui visoje Lietuvoje).</p>
        {/* <p>Kvietimai teikti paraiškas skelbiami kiekvieno metų ketvirčio pirmąją darbo dieną. Sekantis katilų keitimo paramos etapas planuojamas preliminariai 2026 m. liepos 1 d.</p> */}
        <p></p>

        {/* <h1>NAUJIENA</h1>
        <p style={{fontSize: "22px"}}>Kviečiame susitikti parodoje „Ką pasėsi... 2026“! Paroda vyks 2026 m. kovo 26-28 d. VDU Žemės ūkio akademijoje.</p>
        <p style={{fontSize: "22px"}}>Mus rasite 3 paviljone, stendo nr. 29.</p> */}
    </div>
  </>;
}

export default Advert;